var _path, _path2, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTask(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "task",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_26895",
    "data-name": "Path 26895",
    d: "M12.75,18.28l-2.692-2.693L9,16.645l3.75,3.75,6.75-6.75L18.443,12.58Z",
    transform: "translate(-2.25 -3.145)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_26896",
    "data-name": "Path 26896",
    d: "M20,4.25H17.75V3.5A1.5,1.5,0,0,0,16.25,2h-6a1.5,1.5,0,0,0-1.5,1.5v.75H6.5A1.5,1.5,0,0,0,5,5.75V21.5A1.5,1.5,0,0,0,6.5,23H20a1.5,1.5,0,0,0,1.5-1.5V5.75A1.5,1.5,0,0,0,20,4.25ZM10.25,3.5h6v3h-6ZM20,21.5H6.5V5.75H8.75V8h9V5.75H20Z",
    transform: "translate(-1.25 -0.5)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "_Transparent_Rectangle_",
    "data-name": "<Transparent Rectangle>",
    width: 24,
    height: 24,
    fill: "none"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTask);
export default __webpack_public_path__ + "static/media/task.2157360af4d619adcc74b1c594625098.svg";
export { ForwardRef as ReactComponent };